import { clsx, type ClassValue } from "clsx";
import { DateTime } from "luxon";
import { twMerge } from "tailwind-merge";

export const timezone = "Europe/Paris";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export class DateHelper {
  static day = (date: Date) =>
    new Date(date.getFullYear(), date.getMonth(), date.getDate());

  static startOfDay = (date?: Date) =>
    (date ? DateTime.fromJSDate(date) : DateTime.now().setZone(timezone))
      .startOf("day")
      .toJSDate();

  static endOfDay = (date?: Date) =>
    (date ? DateTime.fromJSDate(date) : DateTime.now().setZone(timezone))
      .endOf("day")
      .toJSDate();
}

export const formatDate = (date: Date = new Date()) =>
  DateTime.fromJSDate(new Date(date)).setZone(timezone).toFormat("dd/MM/yyyy");

export const getYearFromDate = (date: Date) =>
  DateTime.fromJSDate(new Date(date)).setZone(timezone).toFormat("yyyy");